module.exports = __webpack_public_path__ + "img/312.5105965d.jpg";